export class PutDataCatalogExternalContextDocumentResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "key",
            "baseName": "key",
            "type": "string",
            "format": ""
        },
        {
            "name": "contentSha256",
            "baseName": "contentSha256",
            "type": "string",
            "format": ""
        },
        {
            "name": "documentId",
            "baseName": "documentId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PutDataCatalogExternalContextDocumentResponse.attributeTypeMap;
    }
    constructor() {
    }
}
